/**
 * Formatting registry - Dependency Injection container.
 * Allows tests to inject mocks without modifying production code (DIP).
 */

import { defaultFormattingRegistry } from './defaultProvider';
import { resetFormattingLocale } from './formattingLocale';
import type { FormattingRegistry } from './types';

let currentRegistry: FormattingRegistry = defaultFormattingRegistry;

/**
 * Sets the formatting registry. Use in tests to inject mocks.
 */
export function setFormattingRegistry(registry: FormattingRegistry): void {
  currentRegistry = registry;
}

/**
 * Gets the current formatting registry.
 */
export function getFormattingRegistry(): FormattingRegistry {
  return currentRegistry;
}

/**
 * Resets to the default registry. Use in afterEach for test cleanup.
 */
export function resetFormattingRegistry(): void {
  currentRegistry = defaultFormattingRegistry;
  resetFormattingLocale();
}
